export default __webpack_public_path__ + "static/media/2.be846b9c.png";